import React from "react"
import {Box, Grid, Skeleton} from "@mui/material"
import PropTypes from "prop-types"

const SummarySkeletonItem = () => {
    return (
        <Box display="flex" gap="7px" flexDirection="column">
            <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                    width: "70%",
                    height: 12,
                    borderRadius: "2px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    "&::after": {
                        background:
                            "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 50%, rgba(255,255,255,0) 100%)",
                    },
                }}
            />

            <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                    width: "90%",
                    height: 18,
                    borderRadius: "2px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    "&::after": {
                        background:
                            "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 50%, rgba(255,255,255,0) 100%)",
                    },
                }}
            />
        </Box>
    )
}

const SummarySkeletonGrid = ({ fields }) => {
    const skeletonItems = fields?.length ? fields : Array.from({ length: 1 })

    return (
        <Grid container spacing={2}>
            {skeletonItems.map((field, index) => (
                <Grid
                    key={field?.label ?? index}
                    item
                    {...(field?.gridProps ?? {
                        xxxs: 4,
                        sm: 4,
                        md: 4,
                    })}
                    sx={{
                        minWidth: 180,
                    }}
                >
                    <SummarySkeletonItem />
                </Grid>
            ))}
        </Grid>
    )
}

SummarySkeletonGrid.propTypes = {
    fields: PropTypes.array,
}

export default SummarySkeletonGrid